import api from "./instance";

export default {
  getCastMembers: (token, page, search) =>
    api
      .get(`/cast-members?page=${page}&perPage=10&search=${search}`, {
        headers: { Authorization: token }
      })
      .then(res => res),
  getShortLink: async link => {
    try {
      const bitlyResponse = await fetch(
        "https://api-ssl.bitly.com/v4/shorten",
        {
          method: "POST",
          headers: {
            Authorization: "Bearer 4417d3dda30223e47adde875dc53506dbdfde2a8",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            long_url: link,
            domain: "bit.ly"
          })
        }
      );

      if (!bitlyResponse.ok) {
        throw new Error(`Bitly API error: ${bitlyResponse.status}`);
      }
      return await bitlyResponse.json();
    } catch (error) {
      console.error("Error getting short link:", error);
      throw error;
    }
  },
  addCastMember: (token, payload) =>
    api
      .post("/cast-members", payload, {
        headers: { Authorization: token }
      })
      .then(res => res),
  editCastMember: (token, payload, id) =>
    api
      .patch(`/cast-members/${id}`, payload, {
        headers: { Authorization: token }
      })
      .then(res => res),
  removeCastMember: (token, id) =>
    api
      .delete(`/cast-members/${id}`, {
        headers: { Authorization: token }
      })
      .then(res => res)
};
